import { isEmptyString } from './is-empty-string';
import { isNil } from '../is-nil/is-nil';

export function isEmptyOrNilString(arg: string | undefined | null): boolean {
  return isNil(arg) || isEmptyString(arg);
}
